import { defineFurniture } from './types.js';

/**
 * Time-boxed drops sold for Kaki Dollars in the regular shop (unlike
 * `rare.ts`, which is Gold/Diamond only). No cap on how many sell — the
 * drop just stops at `limited.endsAt`, never to return.
 */
export const LIMITED_FURNITURE = defineFurniture('seating', {
  phoenix_throne: {
    label: 'Phoenix Throne',
    description: 'Forged once, never again: a throne wreathed in living flame. The priciest seat in the kopitiam.',
    price: 8000,
    solid: false,
    seat: 'facing',
    height: 0.8,
    effect: { type: 'flames', color: '#ff8a1f', color2: '#ffe27a', height: 60 },
    limited: { endsAt: Date.UTC(2026, 9, 16) },
  },
});
